import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import { List } from 'react-virtualized';
export default function () {
    function onClick1(e) {
        this.props.onClickOutside && this.props.onClickOutside(e);
    }
    function onChange2(e) {
        this.setState({ addNewText: e.target.value });
    }
    function onKeyPress3(e) {
        e.key === 'Enter' && _.trim(this.state.addNewText).length > 0 && this.props.onAddNew(this.state.addNewText);
    }
    function onClick4() {
        _.trim(this.state.addNewText).length > 0 && this.props.onAddNew(this.state.addNewText);
    }
    function onClick5(item, itemIndex) {
        this.handleSelectItem(item);
    }
    function repeatF6(item, itemIndex, f, fIndex) {
        return React.createElement('span', { 'className': 'ui-select-dropdown_flags ' + (f.on ? 'on' : '') }, '\r\n            ', f.text, '\r\n          ');
    }
    function onClick7(item, itemIndex, i, iIndex) {
        this.handleSelectItem(i);
    }
    function repeatF8(item, itemIndex, i, iIndex, f, fIndex) {
        return React.createElement('span', { 'className': 'ui-select-dropdown_flags ' + (f.on ? 'on' : '') }, '\r\n                ', f.text, '\r\n              ');
    }
    function repeatI9(item, itemIndex, i, iIndex) {
        return [React.createElement.apply(this, [
                'li',
                {
                    'key': i.value,
                    'className': 'select2-dropdown__list-option select2-dropdown__list-option-group-item ' + (i.value == this.state.selected || i.value == this.state.selected.value ? 'select2-dropdown__list-option--active' : ''),
                    'onClick': onClick7.bind(this, item, itemIndex, i, iIndex)
                },
                i.text,
                '\r\n              ',
                _.map(i.flags, repeatF8.bind(this, item, itemIndex, i, iIndex))
            ])];
    }
    function repeatItem10(item, itemIndex) {
        return [
            !item.items ? React.createElement.apply(this, [
                'li',
                {
                    'key': item.value,
                    'className': 'select2-dropdown__list-option ' + (item.value == this.state.selected || item.value == this.state.selected.value ? 'select2-dropdown__list-option--active' : ''),
                    'onClick': onClick5.bind(this, item, itemIndex)
                },
                item.text,
                '\r\n          ',
                _.map(item.flags, repeatF6.bind(this, item, itemIndex))
            ]) : null,
            item.items && item.items.length > 0 ? [
                item.items && item.items.length > 0 ? React.createElement('li', {
                    'className': 'select2-dropdown__list-option-group',
                    'key': '23031'
                }, '\r\n              ', item.text, '\r\n          ') : null,
                _.map(item.items, repeatI9.bind(this, item, itemIndex))
            ] : null
        ];
    }
    return React.createElement('div', { 'className': classNames('select2-dropdown', { 'select2-dropdown--wide': this.props.wide }) }, React.createElement('div', {
        'className': 'select2-dropdown__title',
        'onClick': onClick1.bind(this)
    }, this.state.selected && this.state.selected.text), this.props.filter !== false ? React.createElement('div', {
        'className': 'select2-dropdown__search',
        'key': '379'
    }, React.createElement('input', {
        'className': 'generic-popup-textbox',
        'placeholder': 'filter',
        'value': this.state.searchText,
        'onChange': this.handleChangeSearchText
    })) : null, React.createElement.apply(this, [
        'ul',
        { 'className': 'select2-dropdown__list' },
        this.props.onAddNew ? React.createElement('li', {
            'className': 'select2-dropdown__list-option select2-dropdown__addNew',
            'key': '645'
        }, !this.state.addNewVisible && !this.props.alwaysShowAdd ? React.createElement('span', {
            'onClick': this.showAddNewInput,
            'key': '750'
        }, '\r\n          Add New ', this.props.addNewItemName ? this.props.addNewItemName : 'Item', '\r\n        ') : null, this.state.addNewVisible || this.props.alwaysShowAdd ? React.createElement('input', {
            'type': 'text',
            'ref': this.setAddNewInputRef,
            'placeholder': 'Add New ' + (this.props.addNewItemName ? this.props.addNewItemName : 'Item'),
            'className': 'generic-popup-textbox',
            'value': this.state.addNewText,
            'onChange': onChange2.bind(this),
            'onKeyPress': onKeyPress3.bind(this),
            'key': '972'
        }) : null, this.state.addNewVisible || this.props.alwaysShowAdd ? React.createElement('span', {
            'className': 'select2-dropdown__addNew-button',
            'onClick': onClick4.bind(this),
            'key': '1485'
        }) : null) : null,
        !this.props.useVirtualizedList ? _.map(this.state.filteredItems, repeatItem10.bind(this)) : null,
        this.props.useVirtualizedList ? React.createElement(List, {
            'width': 630,
            'height': 170,
            'rowCount': this.state.filteredItems.length,
            'rowHeight': 30,
            'rowRenderer': this.rowRenderer,
            'key': '3113'
        }) : null
    ]));
}